import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ label, value, percentage, icon, iconColor, bgClass }) => (
  <div className={`flex flex-col p-5 rounded-xl bg-card shadow-romantic-sm border border-border relative overflow-hidden ${bgClass || ''}`}>
    <div className="absolute top-0 right-0 p-3 opacity-10">
      <Icon name={icon} size={48} color={iconColor} />
    </div>
    <p className="text-sm font-medium text-muted-foreground">{label}</p>
    <div className="flex items-baseline gap-2 mt-2">
      <h3 className="text-3xl font-bold text-foreground">{value}</h3>
      {percentage !== undefined && (
        <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-0.5 rounded-full">
          {percentage}%
        </span>
      )}
    </div>
  </div>
);

const GuestStatsCards = ({ stats }) => {
  const total = stats?.total || 0;
  const newCount = stats?.new || 0;
  const confirmed = stats?.confirmed || 0;
  const pending = stats?.pending || 0;
  const declined = stats?.declined || 0;

  const confirmedPct = total > 0 ? Math.round((confirmed / total) * 100) : 0;
  const declinedPct = total > 0 ? Math.round((declined / total) * 100) : 0;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      <StatCard
        label="Total Guests"
        value={total}
        icon="Users"
        iconColor="var(--color-primary)"
      />
      <StatCard
        label="New"
        value={newCount}
        icon="UserPlus"
        iconColor="#3b82f6"
      />
      <StatCard
        label="Confirmed"
        value={confirmed}
        percentage={confirmedPct}
        icon="CheckCircle"
        iconColor="var(--color-primary)"
        bgClass="bg-primary/5"
      />
      <StatCard
        label="Pending"
        value={pending}
        icon="Clock"
        iconColor="#f59e0b"
      />
      <StatCard
        label="Declined"
        value={declined}
        percentage={declinedPct}
        icon="XCircle"
        iconColor="#ef4444"
      />
    </div>
  );
};

export default GuestStatsCards;
